// extracted by mini-css-extract-plugin
export default {"statusTag":"StatusTag_statusTag__6v--s","tagPill":"StatusTag_tagPill__2x71b","small":"StatusTag_small__qN1Iz"};